<script>
import { Bar } from "vue-chartjs";

let blues = ['#006B8B','#018EC4','#64C0DF','#003E5D','#00609F','#0197D5','#8FCFF2','#012B60','#004E95','#0076BA','#5F86BF','#C0D6ED','#011262','#01267F','#5861A4']

export default {
  extends: Bar,
  data() {
    return {
      chart_options: {
        scales: {
          yAxes: [
            {
              type: "linear", // only linear but allow scale type registration. This allows extensions to exist solely for log scale for instance
              display: true,
              position: "left",
              id: "y-axis-1",
            },
            {
              type: "linear", // only linear but allow scale type registration. This allows extensions to exist solely for log scale for instance
              display: true,
              position: "right",
              id: "y-axis-2",
              gridLines: {
                drawOnChartArea: false,
              },
            },
          ],
        },
        responsive: true,
        maintainAspectRatio: false,
      },
      datas: {},
    };
  },
  mounted() {
    window.setTimeout(() => {
      this.fetchDatas();
    }, 500);
  },
  methods: {
    changeUrl(newUrl) {
      this.url = newUrl;
      this.fetchDatas();
    },
    fetchDatas(draw = null) {
      
      var url = this.url;
      if (this.stringParameters != null && this.stringParameters != "") {
        url += "?" + this.stringParameters;
      }

      let chartConfig = this.getChartConfig();

      axios.get(url).then((response) => {
        this.datas = response.data;
        if (response.data.config != null) {
          this.renderChart(this.datas, response.data.config);
        } else {
          this.renderChart(this.datas, chartConfig);
        }
      });
    },
    drawBarLineGraph(datas_bar) {
      let componentGraph = this;
      let chartConfig = this.getChartConfig();

      let count = datas_bar.datasets.length
      let labels = datas_bar.labels;


      if(count > 1 ) {
        datas_bar.datasets.forEach((el, i) => {
          
          el.backgroundColor = blues[i];
          el.borderColor = blues[i];
        });

        let final = { labels, datasets: datas_bar.datasets };
        
        setTimeout(function () {
          componentGraph.renderChart(final, componentGraph.chart_options);
        }, 1000);
      } else {
          datas_bar.datasets[0].backgroundColor = blues
          datas_bar.datasets[0].borderColor = blues
          let final = { labels, datasets: datas_bar.datasets };
          setTimeout(function () {
          componentGraph.renderChart(final, componentGraph.chart_options);
        }, 1000);
      }


      setTimeout(function () {
        componentGraph.renderChart(datas_bar, chartConfig);
      }, 1000);
    },
    getChartConfig(){
      if (this.extChartConfig == null || this.extChartConfig == ""){
        return this.chart_options;
      } else {
        return this.extChartConfig;
      }
    }
  },
  props: {
    url: {
      type: String,
      requred: true,
    },
    stringParameters: {
      type: String,
      required: false,
    },
    extChartConfig: {
      type: Object,
      required: false
    }
  },
};
</script>
